import React from 'react';
import AdminNavbar from '../AdminNavbar';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const isInvoicePage = location.pathname.startsWith('/invoice');

  const allowedRoles = ['admin', 'factory', 'customer-service'];

  if (!user) return null; // Optionally show loader
  if (!allowedRoles.includes(user.role)) return <Navigate to="/unauthorized" />;

  return (
    <>
      {!isInvoicePage && <AdminNavbar />}
      <main className={isInvoicePage ? '' : 'pt-16 px-4'}>
        {children}
      </main>
    </>
  );
};

export default AdminLayout;
